import { ammRestRequest } from 'core/utils/backend-service';
import { DeviceTypeSummary, TestSummary } from 'modules/settings/pods/settings-materials/material-definition.vm';

export const getDeviceTypes = (): Promise<DeviceTypeSummary[]> =>
    ammRestRequest('GET', 'api/v1/device-types').then((response) => response.json());

export const getTests = (): Promise<TestSummary[]> =>
    ammRestRequest('GET', 'api/v1/tests').then((response) => response.json());
